import React from "react";

/** Prev/next pager used by every paginated learner list. */
const Paginator = ({page = 1, totalPages = 1, onChange, className = ""}) => {
  if (!totalPages || totalPages <= 1) return null;
  const button =
    "rounded-md border border-slate-200 px-3 py-2 text-sm font-medium text-slate-700 transition-colors hover:border-blue-200 hover:bg-blue-50 hover:text-blue-700 disabled:cursor-not-allowed disabled:opacity-50";
  return (
    <div className={`flex items-center justify-center gap-3 pt-5 ${className}`}>
      <button type="button" className={button} disabled={page <= 1} onClick={() => onChange(page - 1)}>
        Previous
      </button>
      <span className="text-sm text-slate-500">
        Page {page} of {totalPages}
      </span>
      <button
        type="button"
        className={button}
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
      >
        Next
      </button>
    </div>
  );
};

export default Paginator;
